// src/pages/users/users-list.jsx
import { useContext, useEffect, useState } from "react";
import { PortalMainLayout } from "../../components/layout/portal-main-layout";
import { AuthorisedPage } from "../auth/authorised-page";
import { CognitoContext } from "../../contexts/cognito/cognito-provider";
import { Link } from "react-router-dom";
import { CoreServiceSelector } from "../../services/core/service-selector";
import { useAppLoading } from "../../components/layout/app-loading-provider";
import { SecondaryButton } from "../../components/form/secondary-button";
import {HelpSupport} from "../../components/users/help-support"

export const HelpSupportPage = () => {
  const [data, setData] = useState([]);
  const { showLoading, hideLoading } = useAppLoading();
  const [pageState, setPageState] = useState({ isLoading: true });
  const [unauthorised, setUnauthorised] = useState({ show: false });
  const { state } = useContext(CognitoContext);


  return (
    <AuthorisedPage>
      <PortalMainLayout isUnauthorised={unauthorised.show}>
        <HelpSupport />
      </PortalMainLayout>
    </AuthorisedPage>
  );
};
